import * as actions from '../actions/actionConstants.js';

const initialState = {
  todaysWeather: {},
  fetchingWeatherStatus: '',
  error: ''
};

const weatherReducer = (state = initialState, action) => {
	switch(action.type){
		case actions.GET_TODAYS_WEATHER:
			return{
				...state,
				fetchingWeatherStatus: 'Loading'
			};
		case actions.GET_TODAYS_WEATHER_SUCCESS:
			return{
				...state,
				todaysWeather: {
					...action.todaysWeather
				},
				fetchingWeatherStatus: 'Loaded'
			};
		case actions.GET_TODAYS_WEATHER_ERROR:
			return{
				...state,
				error: action.error,
				fetchingWeatherStatus: 'Error'
			};
		default:
			return state;
	}
};

export default weatherReducer;



// WEBPACK FOOTER //
// ./src/reducers/weather.js